var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 43.6",
    style: {
      enableBackground: "new 0 0 45 43.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,28.6H2c-1.1,0-2,0.9-2,2v4.1c0,4.9,4,8.9,8.9,8.9h27.3c4.9,0,8.9-4,8.9-8.9v-4.1 C45,29.6,44.1,28.6,43,28.6L43,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,15H43c1.1,0,2-0.9,2-2.1V8.9C45,4,41,0,36.1,0h-3.4v6.1c0,1.1-0.9,2-2,2s-2-0.9-2-2.1V0h-4.1v6.1 c0,1.1-0.9,2-2,2s-2-0.9-2-2.1V0h-4.1v6.1c0,1.1-0.9,2-2.1,2s-2.1-0.9-2.1-2.1V0H8.9C4,0,0,4,0,8.9v4.1C0,14.1,0.9,15,2,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.3,19.9c-1,0.3-1.7,0.6-3.4,0.6l0,0c-1.7,0-2.5-0.2-3.4-0.6c-1.1-0.4-2.4-0.8-4.7-0.8l0,0 c-2.4,0-3.6,0.4-4.7,0.8c-1,0.3-1.7,0.6-3.4,0.6l0,0c-1.7,0-2.5-0.2-3.4-0.6c-1.1-0.4-2.4-0.8-4.7-0.8l0,0c-2.4,0-3.6,0.4-4.7,0.8 c-1,0.3-1.7,0.6-3.4,0.6l0,0c-1.7,0-2.5-0.2-3.4-0.6l0,0c-1.1-0.4-2.2,0.2-2.6,1.3s0.2,2.2,1.3,2.6c1.1,0.4,2.4,0.8,4.7,0.8l0,0 c2.4,0,3.6-0.4,4.7-0.8c1-0.3,1.7-0.6,3.4-0.6l0,0c1.7,0,2.5,0.2,3.4,0.6c1.1,0.4,2.4,0.8,4.7,0.8l0,0c2.4,0,3.6-0.4,4.7-0.8 c1-0.3,1.7-0.6,3.4-0.6l0,0c1.7,0,2.5,0.2,3.4,0.6c1.1,0.4,2.4,0.8,4.7,0.8l0,0c2.4,0,3.6-0.4,4.7-0.8c1.1-0.4,1.7-1.5,1.3-2.6 S43.4,19.5,42.3,19.9L42.3,19.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastfood);
export default __webpack_public_path__ + "static/media/fastfood.b347ed49112aa99ca68550e7a34c1e75.svg";
export { ForwardRef as ReactComponent };